import { useContext } from 'react'
import { LandingPageViewmodelContext } from './landing-page.provider'
import type { LandingPageViewmodel } from './landing-page.viewmodel'

export function useLandingPageViewmodel(): LandingPageViewmodel {
  const landingPageViewmodel = useContext(LandingPageViewmodelContext)

  if (!landingPageViewmodel) {
    throw new Error('useLandingPageViewmodel must be used within LandingPageProvider')
  }

  return landingPageViewmodel
}
